var _circle, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArtistHub = function SvgArtistHub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_435_55)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_435_55",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "var(--on-surface)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_435_55)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_435_55)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#AB4AE7",
    fillOpacity: 0.2,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.6384 14.6563L39.3094 12.157L39.3082 12.1563C37.5694 11.1528 34.8687 11.4617 30.0449 12.0133L22.2949 12.8995C16.8148 13.5261 14.0747 13.8394 12.3723 15.7969C10.6699 17.7544 10.6699 20.5917 10.6699 26.2662V30.2786C10.6699 35.9531 10.6699 38.7904 12.3723 40.3585C12.5762 40.5463 12.7949 40.7071 13.0315 40.8437L17.3605 43.343C17.1244 43.2066 16.906 43.046 16.7024 42.8585C15 41.2904 15 38.4531 15 32.7786V28.7662C15 23.0917 15 20.2544 16.7024 18.2969C18.4049 16.3394 21.1449 16.0261 26.625 15.3995L34.375 14.5133C38.5372 14.0373 41.1188 13.7421 42.8656 14.3147L44.2976 15.1415C44.0937 14.9537 43.8749 14.7929 43.6384 14.6563Z",
    fill: "#AB4AE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6384 14.6563L39.3094 12.157L39.3082 12.1563C37.5694 11.1528 34.8687 11.4617 30.0449 12.0133L22.2949 12.8995C16.8148 13.5261 14.0747 13.8394 12.3723 15.7969C10.6699 17.7544 10.6699 20.5917 10.6699 26.2662V30.2786C10.6699 35.9531 10.6699 38.7904 12.3723 40.3585C12.5762 40.5463 12.7949 40.7071 13.0315 40.8437L17.3605 43.343C17.1244 43.2066 16.906 43.046 16.7024 42.8585C15 41.2904 15 38.4531 15 32.7786V28.7662C15 23.0917 15 20.2544 16.7024 18.2969C18.4049 16.3394 21.1449 16.0261 26.625 15.3995L34.375 14.5133C38.5372 14.0373 41.1188 13.7421 42.8656 14.3147L44.2976 15.1415C44.0937 14.9537 43.8749 14.7929 43.6384 14.6563Z",
    fill: "var(--on-surface)",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 28.7662C15 23.0917 15 20.2544 16.7024 18.2969C18.4049 16.3394 21.1449 16.0261 26.625 15.3995L34.375 14.5133C39.8551 13.8866 42.5951 13.5733 44.2976 15.1415C46 16.7096 46 19.5469 46 25.2214V29.2338C46 34.9083 46 37.7455 44.2976 39.7031C42.5951 41.6606 39.8551 41.9739 34.375 42.6005L26.625 43.4867C21.1449 44.1134 18.4049 44.4267 16.7024 42.8585C15 41.2904 15 38.4531 15 32.7786V28.7662Z",
    fill: "#B151C9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3899 28.0122C40.3899 29.3929 39.2775 30.6358 37.9052 30.7883C36.5329 30.9408 35.4205 29.9451 35.4205 28.5644C35.4205 27.1837 36.5329 25.9408 37.9052 25.7883C39.2775 25.6358 40.3899 26.6315 40.3899 28.0122Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4694 23.4478C27.4694 24.8286 26.357 26.0714 24.9847 26.2239C23.6124 26.3764 22.5 25.3807 22.5 24C22.5 22.6193 23.6124 21.3764 24.9847 21.2239C26.357 21.0714 27.4694 22.0671 27.4694 23.4478Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4694 35.4478C27.4694 36.8286 26.357 38.0714 24.9847 38.2239C23.6124 38.3764 22.5 37.3807 22.5 36C22.5 34.6193 23.6124 33.3764 24.9847 33.2239C26.357 33.0714 27.4694 34.0671 27.4694 35.4478Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3178 22.781L38.2383 27.3454C38.6066 27.4755 38.8654 27.8082 38.901 28.1971C38.9366 28.5861 38.7425 28.9602 38.404 29.155L25.4835 36.5906L24.4859 34.8572L35.521 28.5066L24.6516 24.6668L25.3178 22.781Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "url(#paint0_linear_435_55)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_435_55",
    x: -4,
    y: -2,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    "in": "SourceAlpha",
    result: "effect1_dropShadow_435_55"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_435_55"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.101961 0 0 0 0 0.666667 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_435_55",
    result: "effect2_dropShadow_435_55"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_435_55",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_435_55",
    x1: 0,
    y1: 0,
    x2: 56,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_435_55"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
};
export default SvgArtistHub;